import { DependencyList, useLayoutEffect, useRef, useState } from "react"
import { isShowingEllipsis } from "@/utils/."

export function useTruncation<T extends HTMLElement>(
   dep: DependencyList[number]
) {
   const ref = useRef<T>(null)
   const [isTruncated, setIsTruncated] = useState(false)

   useLayoutEffect(() => {
      if (ref.current) {
         setIsTruncated(isShowingEllipsis(ref.current))
      }
   }, [dep])

   return [ref, isTruncated] as const
}
